// removed by extract-text-webpack-plugin
module.exports = {"listModal":"listModal_listModal_UN2Sa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/regulatoryStatistical/index/state/newest/listModal.scss
// module id = 1570
// module chunks = 0